import { View } from "@/components/ui";
// import { Link } from "@/components/shared/link";
// import { ArrowLeft } from "@/components/shared/icons";
import { Typography } from "@/components/shared/typography";
import { UpdateAddressForm } from "../UpdateAddressForm";
import { IconButton } from "@/components/ui/icon-button/index.web";
import { useRoute } from "@/components/shared/router";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import type { UpdateAddressProps } from "@/types/profile";

export const UpdateAddressScreen = ({
  onSubmit,
  updateAddressLoading,
  showTooltip,
}: UpdateAddressProps) => {
  const { push } = useRoute();
  const { isMobile } = useWindowDimensions();
  return (
    <View>
      <View className="static flex flex-row items-start justify-between border-b md:mb-8 md:pb-4">
        <View className="flex flex-row items-center gap-2 p-4 md:p-0">
          {/* CONSISTENECY PROBLEM <Link href="/profile/addresses">
            <ArrowLeft className="visible size-5" />
          </Link> */}
          <IconButton
            variant={isMobile ? "ghost" : "secondary"}
            color="foreground"
            iconName="arrowLeft"
            rounded="full"
            className="p-0 md:px-3 md:py-2"
            onClick={() => push({ pageKey: "addresses" })}
          />
          <Typography variant="label-md">Update Address</Typography>
        </View>
      </View>

      <UpdateAddressForm
        onSubmit={onSubmit}
        updateAddressLoading={updateAddressLoading}
        showTooltip={showTooltip}
      />
    </View>
  );
};
